










































































































import { Component, Vue } from 'vue-property-decorator';
import { ApiService, curApiService, EnrolProfilePage } from '@/services/ApiService';
import { curPref, Preferences } from '@/services/Preferences';
import Error from '@/components/Error.vue';
import Loading from '@/components/Loading.vue';
import SearchBox from '@/components/SearchBox.vue';
import PageNav from '@/components/PageNav.vue';
import EnrolProfileRow from '@/components/admin/EnrolProfileRow.vue';
import EnrolProfileRowMobile from '@/components/admin/EnrolProfileRowMobile.vue';
import CreateEnrolProfile from '@/components/admin/CreateEnrolProfile.vue';
import DeleteEnrolProfile from '@/components/admin/DeleteEnrolProfile.vue';
import EditEnrolProfile from '@/components/admin/EditEnrolProfile.vue';
import { EnrolProfile, Enterprise } from '@/types';
import _ from 'lodash';

@Component({
  components: {
    Error,
    Loading,
    EnrolProfileRow,
    EnrolProfileRowMobile,
    SearchBox,
    PageNav,
    CreateEnrolProfile,
    DeleteEnrolProfile,
    EditEnrolProfile,
  },
})
export default class EnrolProfileList extends Vue {
  
  status:'view-all'|'create'|'edit'|'delete' = 'view-all';

  selectedEnrolProfile:EnrolProfile = {} as EnrolProfile;

  httpBusy:boolean = false;
  error:string = '';
  pageList:EnrolProfilePage[] = [];
  curPage:EnrolProfilePage = {} as EnrolProfilePage;
  searchTerm = curPref.retrieve('noc-enrol-profile-list-search-term', '');
  enrolProfileList:EnrolProfile[] = [];
  enterpriseList:Enterprise[] = [];
  
  // services
  apiService:ApiService = curApiService;
  
  mounted() {

    if(this.$route.params.searchTerm)
      this.searchTerm = this.$route.params.searchTerm;

    this.refreshData();
  }

  async refreshData() {

    this.httpBusy = true;

    const entReq = this.apiService.getEnterprises({});
    const enrolReq = this.apiService.getEnrolProfilesPaginated({searchTerm:this.searchTerm}); 

    let entReply, enrolReply;

    [entReply, enrolReply] = await Promise.all([entReq,enrolReq]);

    this.httpBusy = false;

    if(entReply.httpCode === 403 || enrolReply.httpCode === 403)
      return this.$router.push({name:'login'});
    
    if(entReply.errorMsg)
      return this.error = `Unable to load enterprises because ${entReply.errorMsg}`;
    
    if(enrolReply.errorMsg)
      return this.error = `Unable to load enrolment profiles because ${enrolReply.errorMsg}`;
    
    this.enterpriseList = entReply.entList!;
    this.pageList = enrolReply.pageList!;

    // we set the current page
    if(this.pageList.length > 0) {

      // we call the reset on the component
      (this.$refs.pageNav as PageNav).reset();

      this.curPage = this.pageList[0];
    }
      
  }

  newSearchText(newSearchText:string) {
    curPref.store('noc-enrol-profile-list-search-term', newSearchText);
    this.searchTerm = newSearchText;
    this.refreshData();
  }

  changeStatus(newStatus:'view-all'|'create'|'edit'|'delete', selectedEnrolProfile?:EnrolProfile) {
    
    this.status = newStatus;

    if(newStatus === 'view-all')
      this.refreshData();

    if(selectedEnrolProfile)
      this.selectedEnrolProfile = selectedEnrolProfile;
  }

  get showPageNav():boolean {
    return this.pageList.length > 0 && !this.httpBusy;
  }

  get showRows():boolean {
    return this.pageList.length > 0 && !this.httpBusy;
  }

  get showNoMatches():boolean {
    return !this.httpBusy && this.pageList.length === 0 && this.searchTerm !== '' && this.error === '';
  }

  get usedEnrolIdList():string[] {

    return _.uniq(this.enterpriseList
      .map(ent => ent.nwServer && ent.nwServer.actility && ent.nwServer.actility.enrolId ? ent.nwServer.actility.enrolId : 'default'));
  }

  changePage(newPageNum:number) {
    this.curPage = this.pageList[newPageNum];
  }


}
